import {mapFields} from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  methods: {

  },
  computed: {
    ...mapFields('storages', {storagesIsFetched:'fetched'}),
    ...mapFields('suppliers', ['suppliers']),
    ...mapFields('storages', ['storages']),
    types(){
      let result = [];
      this.storages.forEach((storage)=>{
        result.push(
          {
            name: this.$t('common.storage')+': '+storage.name,
            type:'storage',
            type_value: parseInt(storage.id)
          });
      })
      this.suppliers.forEach((supplier)=>{
        result.push(
          {
            name: this.$t('common.supplier')+': '+supplier.name,
            type:'supplier',
            type_value: parseInt(supplier.id)
          });
      })

      return result;
    }
  }
}